import { dayjs, formatDate, SUPPORT_FORMAT_DATE_LIST } from '@/utils';
import React, { memo, useCallback, useEffect, useState } from 'react';

import type { Dayjs } from 'dayjs';
import { Field, FieldProps } from 'formik';
import { isEmpty } from 'ramda';

import { IDatePickerProps } from '../date-picker';
import TimePicker from '../time-picker';

export interface IFTimePickerProps extends IDatePickerProps {
	name: string;
	onSave?: () => void;
}

const FTimePicker: React.FC<IFTimePickerProps> = ({
	name,
	onSave,
	...rest
}) => {
	const [enter, setEnter] = useState(false);

	return (
		<div>
			<Field name={name}>
				{({
					field, // { name, value, onChange, onBlur }
					form: { setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
					meta,
				}: FieldProps) => {
					useEffect(() => {
						if (enter) {
							onSave?.();
							setEnter(false);
						}
					}, [enter, field.value]);

					const _onChange = useCallback(
						(date: Dayjs | null, dateString: string | string[]) => {
							setFieldValue(name, formatDate(date, { outputFormat: 'HH:mm' }));
						},
						[setFieldValue, name]
					);

					const handleKeyDown = useCallback(
						(event: React.KeyboardEvent<HTMLElement>) => {
							if (event.key === 'Enter') {
								if (
									isEmpty((event.target as any)?.value) ||
									dayjs(
										(event.target as any)?.value,
										SUPPORT_FORMAT_DATE_LIST
									).isValid()
								) {
									setEnter(true);
								}
							}
						},
						[]
					);

					return (
						<TimePicker
							{...field}
							name={name}
							{...rest}
							touched={meta.touched}
							errorCode={meta.error}
							onChange={_onChange}
							onKeyDown={handleKeyDown}
							allowClear
						/>
					);
				}}
			</Field>
		</div>
	);
};

export default memo(FTimePicker);
